import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { RoomCode } from "../models/quote";

export const ROOM_LABELS: ILabels = {
    [RoomCode.Single]: Yii.t("wui-shared-js", "Chambre simple"),
    [RoomCode.Double]: Yii.t("wui-shared-js", "Chambre double"),
    [RoomCode.Twin]: Yii.t("wui-shared-js", "Lits jumeaux"),
    [RoomCode.Triple]: Yii.t("wui-shared-js", "Chambre triple"),
    [RoomCode.Quad]: Yii.t("wui-shared-js", "Chambre quadruple"),
    [RoomCode.Quint]: Yii.t("wui-shared-js", "Cinq couchages"),
    [RoomCode.Sext]: Yii.t("wui-shared-js", "Six couchages"),
    [RoomCode.Sept]: Yii.t("wui-shared-js", "Sept couchages"),
    [RoomCode.Eight]: Yii.t("wui-shared-js", "Huit couchages"),
    [RoomCode.Nine]: Yii.t("wui-shared-js", "Neuf couchages"),
    [RoomCode.Ten]: Yii.t("wui-shared-js", "Dix couchages"),
    [RoomCode.Dormitory]: Yii.t("wui-shared-js", "Dortoir"),
    [RoomCode.Family]: Yii.t("wui-shared-js", "Famille"),
    [RoomCode.Unknown]: Yii.t("wui-shared-js", "Type de chambre inconnu"),
};